import styled from "styled-components";
import Button from "../../Button";

const microsoftLogo = encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21"><rect x="1" y="1" width="9" height="9" fill="#F25022"/><rect x="1" y="11" width="9" height="9" fill="#00A4EF"/><rect x="11" y="1" width="9" height="9" fill="#7FBA00"/><rect x="11" y="11" width="9" height="9" fill="#FFB900"/></svg>`
);

export const SsoMicrosoft = styled(Button)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 41px;
    padding: 0 12px;
    background-color: #2F2F2F;
    border: 1px solid #8C8C8C;
    border-radius: 2px;
    color: #FFFFFF;
    font-family: "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: 15px;
    font-weight: 600;

    &::before {
        content: '';
        width: 21px;
        height: 21px;
        flex-shrink: 0;
        background-image: url("data:image/svg+xml,${microsoftLogo}");
        background-size: contain;
        background-repeat: no-repeat;
    }

    &:hover {
        background-color: #3B3B3B;
    }

    &:disabled,
    &[disabled] {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;